import { ILocationPath, Location } from './location';
import { AzureBlobFSLinkedService } from '../../linkedservice/azure-blob-fs.linkedservice';
import { Metamodel } from '../../base/model';
import { IAttribute, IModel } from '../../base/annotation';
import { FilePath } from '../file-path';
import { stringIsNullOrEmpty } from '../../../shared/utils/string.util';
import { shellStringResources } from '../../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'AzureBlobFSLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(AzureBlobFSLinkedService)
    }
})
export class AzureBlobFSLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;
    public static readonly CONTAINER: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: shellStringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Container,
        association: 'CONTAINER',
        templatable: true
    })
    public container?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
        this.container = path.container;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', AzureBlobFSLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', AzureBlobFSLocation.FILE_NAME, path);
        this.setPathPropertyValue('container', AzureBlobFSLocation.CONTAINER, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        path.container = this.container;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: AzureBlobFSLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: AzureBlobFSLocation.FILE_NAME.templateValue(this) || this.fileName,
            container: AzureBlobFSLocation.CONTAINER.templateValue(this) || this.container
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && AzureBlobFSLocation.FILE_NAME.templateValue(this)
            ? false
            : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(AzureBlobFSLocation.CONTAINER.templateValue(this)) ||
            !stringIsNullOrEmpty(AzureBlobFSLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(AzureBlobFSLocation.FILE_NAME.templateValue(this));
    }
}
